import "../../node_modules/slick-carousel/slick/slick.js"; // loading from vendor because of overwrite https://stackoverflow.com/a/40369879
import UIkit from "uikit";
import { CountUp } from "countup.js";

var custom = (function($, window, document, Drupal, UIkit, CountUp) {
  Drupal.behaviors.slickGallery = {
    attach: function(context) {
      $(function() {
        $(".slider-block", context).each(function() {
          let $this = $(this);
          $this.find(".carousel_gallery").slick({
            infinite: true,
            nextArrow:
              '<div class="slick-next"><svg class="w-8 h-24 lg:w-12 lg:h-36" xmlns="http://www.w3.org/2000/svg"><svg viewBox="0 0 12 36" height="100%" width="100%"><path fill="#961A32" d="M737.311613,420.980672 L736.055144,420.145426 C736,420.108224 735.98434,420.03502 736.016742,419.978617 L745.868083,403.063687 C745.889684,403.025285 745.889684,402.976083 745.868083,402.93768 L736.016742,386.022751 C735.98434,385.966348 736,385.893144 736.055144,385.855942 L737.311613,385.020696 C737.371616,384.981094 737.45322,385 737.489222,385.061498 L747.983799,402.93768 C748.0054,402.976083 748.0054,403.025285 747.983799,403.063687 L737.489222,420.93987 C737.45322,421.002273 737.371616,421.020274 737.311613,420.980672" transform="translate(-736 -385)" /></svg></svg></div>',
            prevArrow:
              '<div class="slick-prev"><svg class="w-8 h-24 lg:w-12 lg:h-36" xmlns="http://www.w3.org/2000/svg"><svg viewBox="0 0 12 36" height="100%" width="100%"><path fill="#961A32" d="M1.31161271,420.980672 L0.0551436666,420.145426 C0,420.108224 -0.0156602238,420.03502 0.0167415565,419.978617 L9.86808286,403.063687 C9.88968404,403.025285 9.88968404,402.976083 9.86808286,402.93768 L0.0167415565,386.022751 C-0.0156602238,385.966348 0,385.893144 0.0551436666,385.855942 L1.31161271,385.020696 C1.371616,384.981094 1.45322049,385 1.48922246,385.061498 L11.9837991,402.93768 C12.0054003,402.976083 12.0054003,403.025285 11.9837991,403.063687 L1.48922246,420.93987 C1.45322049,421.002273 1.371616,421.020274 1.31161271,420.980672" transform="matrix(-1 0 0 1 12 -385)" /></svg></svg></div>'
          });
        });
      });

      $(function() {
        $(".slider-block", context).each(function() {
          let $this = $(this);
          $this.find(".gallery_control").slick({
            asNavFor: ".carousel_gallery",
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            dots: false,
            focusOnSelect: true,
            prevArrow: false,
            nextArrow: false
          });
        });
      });
    }
  };

  Drupal.behaviors.slickGalleryControl = {
    attach: function(context) {
      $(function() {
        $(".slider-block", context).each(function() {
          let $this = $(this);
          $this.find(".gallery_control").slick({
            infinite: true,
            asNavFor: "carousel_gallery"
          });
        });
      });
    }
  };

  // Slick Slider Block
  Drupal.behaviors.sliderBlock = {
    attach: function(context) {
      $(function() {
        $(".slider-block", context).each(function() {
          let $this = $(this);
          $this.find(".slick-carousel").slick({
            dots: true,
            infinite: true,
            nextArrow:
              '<div class="slick-next"><svg class="w-8 h-24 lg:w-12 lg:h-36" xmlns="http://www.w3.org/2000/svg"><svg viewBox="0 0 12 36" height="100%" width="100%"><path fill="#961A32" d="M737.311613,420.980672 L736.055144,420.145426 C736,420.108224 735.98434,420.03502 736.016742,419.978617 L745.868083,403.063687 C745.889684,403.025285 745.889684,402.976083 745.868083,402.93768 L736.016742,386.022751 C735.98434,385.966348 736,385.893144 736.055144,385.855942 L737.311613,385.020696 C737.371616,384.981094 737.45322,385 737.489222,385.061498 L747.983799,402.93768 C748.0054,402.976083 748.0054,403.025285 747.983799,403.063687 L737.489222,420.93987 C737.45322,421.002273 737.371616,421.020274 737.311613,420.980672" transform="translate(-736 -385)" /></svg></svg></div>',
            prevArrow:
              '<div class="slick-prev"><svg class="w-8 h-24 lg:w-12 lg:h-36" xmlns="http://www.w3.org/2000/svg"><svg viewBox="0 0 12 36" height="100%" width="100%"><path fill="#961A32" d="M1.31161271,420.980672 L0.0551436666,420.145426 C0,420.108224 -0.0156602238,420.03502 0.0167415565,419.978617 L9.86808286,403.063687 C9.88968404,403.025285 9.88968404,402.976083 9.86808286,402.93768 L0.0167415565,386.022751 C-0.0156602238,385.966348 0,385.893144 0.0551436666,385.855942 L1.31161271,385.020696 C1.371616,384.981094 1.45322049,385 1.48922246,385.061498 L11.9837991,402.93768 C12.0054003,402.976083 12.0054003,403.025285 11.9837991,403.063687 L1.48922246,420.93987 C1.45322049,421.002273 1.371616,421.020274 1.31161271,420.980672" transform="matrix(-1 0 0 1 12 -385)" /></svg></svg></div>'
          });
        });
      });

      $(function() {
        $(".slider-block", context).each(function() {
          let $this = $(this);
          $this.find(".carousel_gallery").slick({
            dots: true,
            infinite: true,
            nextArrow:
              '<div class="slick-next"><svg class="w-8 h-24 lg:w-12 lg:h-36" xmlns="http://www.w3.org/2000/svg"><svg viewBox="0 0 12 36" height="100%" width="100%"><path fill="#961A32" d="M737.311613,420.980672 L736.055144,420.145426 C736,420.108224 735.98434,420.03502 736.016742,419.978617 L745.868083,403.063687 C745.889684,403.025285 745.889684,402.976083 745.868083,402.93768 L736.016742,386.022751 C735.98434,385.966348 736,385.893144 736.055144,385.855942 L737.311613,385.020696 C737.371616,384.981094 737.45322,385 737.489222,385.061498 L747.983799,402.93768 C748.0054,402.976083 748.0054,403.025285 747.983799,403.063687 L737.489222,420.93987 C737.45322,421.002273 737.371616,421.020274 737.311613,420.980672" transform="translate(-736 -385)" /></svg></svg></div>',
            prevArrow:
              '<div class="slick-prev"><svg class="w-8 h-24 lg:w-12 lg:h-36" xmlns="http://www.w3.org/2000/svg"><svg viewBox="0 0 12 36" height="100%" width="100%"><path fill="#961A32" d="M1.31161271,420.980672 L0.0551436666,420.145426 C0,420.108224 -0.0156602238,420.03502 0.0167415565,419.978617 L9.86808286,403.063687 C9.88968404,403.025285 9.88968404,402.976083 9.86808286,402.93768 L0.0167415565,386.022751 C-0.0156602238,385.966348 0,385.893144 0.0551436666,385.855942 L1.31161271,385.020696 C1.371616,384.981094 1.45322049,385 1.48922246,385.061498 L11.9837991,402.93768 C12.0054003,402.976083 12.0054003,403.025285 11.9837991,403.063687 L1.48922246,420.93987 C1.45322049,421.002273 1.371616,421.020274 1.31161271,420.980672" transform="matrix(-1 0 0 1 12 -385)" /></svg></svg></div>'
          });
        });
      });

      $(function() {
        $(".slider-block", context).each(function() {
          let $this = $(this);
          $this.find(".gallery_control").slick({
            infinite: true,
            asNavFor: "carousel_gallery"
          });
        });
      });
    }
  };

  Drupal.getExposedFilterSelectMap = function(
    item,
    ignoreSelectNames,
    include
  ) {
    const selectMap = new Map();
    item.find(".form-type-select select").each(function() {
      var selectName = $(this).attr("name");
      var selectId = $(this).attr("id");
      // ignore sort select fields
      if (
        (include && ignoreSelectNames.includes(selectName)) ||
        (!include && !ignoreSelectNames.includes(selectName))
      ) {
        $(this)
          .find("option")
          .each(function() {
            var id = $(this).val();
            var value = $(this).text();
            // ignore "All" option
            if (id !== "All") {
              var values = selectMap.get(selectId);
              var selected = $(this).attr("selected") === "selected";
              if (Array.isArray(values)) {
                values.push([id, value, selected]);
              } else {
                values = [[id, value, selected]];
              }
              selectMap.set(selectId, values);
            }
          });
      }
    });
    return selectMap;
  };

  Drupal.selectAllExposedFilters = function(item, ignoreSelectNames, include) {
    item.find(".form-type-select select").each(function() {
      var selectName = $(this).attr("name");
      if (
        (include && ignoreSelectNames.includes(selectName)) ||
        (!include && !ignoreSelectNames.includes(selectName))
      ) {
        $(this).val("All");
      }
    });
  };

  Drupal.createExposedFilterHtml = function(id, selectMap, classes) {
    let html = "";
    if (Array.isArray(classes) && classes.length) {
      html += '<div id="' + id + '" class="' + classes.join(" ") + '"><ul>';
    } else {
      html += '<div id="' + id + '"><ul>';
    }
    let writeClass = function(selected) {
      if (selected) {
        return 'class="active"';
      } else {
        return "";
      }
    };
    selectMap.forEach(function(value, key) {
      for (var i = 0; i < value.length; i++) {
        html +=
          "<li><button " +
          writeClass(value[i][2]) +
          ' select-id="' +
          key +
          '" list-key="' +
          value[i][0] +
          '">' +
          value[i][1] +
          "</button></li>";
      }
    });
    html += "</ul></div>";
    return html;
  };

  Drupal.exposedFilterSelectButton = function() {
    let classes = "";
    let text = Drupal.t("Filter");
    if (Drupal.exposedFilterOpen) {
      classes = ' class="flip"';
    }
    if (drupalSettings.path.currentLanguage === "fr") {
      text = "Filtre";
    } else if (drupalSettings.path.currentLanguage === "it") {
      text = "Filtro";
    }

    return (
      '<div id="exposed-filter-select-list-button"' +
      classes +
      ">" +
      text +
      "</div>"
    );
  };

  Drupal.behaviors.exposedFilterHack = {
    attach: function(context, settings) {
      $(
        once(
          "exposedFilterHack",
          ".view-ongoing form.views-exposed-form, .view-event form.views-exposed-form"
        )
      ).each(function() {
        var sort_map = Drupal.getExposedFilterSelectMap(
          $(this),
          ["sort_order"],
          true
        );
        if (sort_map.size) {
          var sortFilter = Drupal.createExposedFilterHtml(
            "exposed-filter-sort-list",
            Drupal.getExposedFilterSelectMap($(this), ["sort_order"], true),
            []
          );
          $(this)
            .parent()
            .append(sortFilter);
        }
        let classes = [];
        if (Drupal.exposedFilterOpen) {
          classes = ["show"];
        }
        // create "all" filter
        let map = Drupal.getExposedFilterSelectMap(
          $(this),
          ["sort_order", "sort_by"],
          false
        );
        let newMap = new Map();
        newMap.set("all", [["all", "All", false]]);
        map.forEach(function(value, key) {
          newMap.set(key, value);
        });
        var newFilter =
          Drupal.exposedFilterSelectButton() +
          Drupal.createExposedFilterHtml(
            "exposed-filter-select-list",
            newMap,
            classes
          );
        const observer = new MutationObserver(function(
          mutationsList,
          observer
        ) {
          for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
              $("#exposed-filter-select-list button").click(function(e) {
                var viewFilter = $(this).closest(".view-filters");
                Drupal.selectAllExposedFilters(
                  viewFilter,
                  ["sort_order", "sort_by"],
                  false
                );
                $("select#" + $(this).attr("select-id")).val(
                  $(this).attr("list-key")
                );
                viewFilter
                  .find(
                    'form.views-exposed-form .form-actions input[type="submit"]'
                  )
                  .click();
              });
              $("#exposed-filter-sort-list button").click(function(e) {
                var viewFilter = $(this).closest(".view-filters");
                Drupal.selectAllExposedFilters(
                  viewFilter,
                  ["sort_order"],
                  true
                );
                $("select#" + $(this).attr("select-id")).val(
                  $(this).attr("list-key")
                );
                viewFilter
                  .find(
                    'form.views-exposed-form .form-actions input[type = "submit"]'
                  )
                  .click();
              });
              $("#exposed-filter-select-list-button").click(function() {
                addClassOnclick(
                  $("#exposed-filter-select-list-button"),
                  "flip"
                );
                addClassOnclick($("#exposed-filter-select-list"), "show");
                Drupal.exposedFilterOpen = !Drupal.exposedFilterOpen;
              });
              observer.disconnect();
            }
          }
        });
        observer.observe($(this).parent()[0], {
          attributes: false,
          childList: true,
          subtree: true
        });
        $(this)
          .parent()
          .append(newFilter);
      });
    }
  };

  Drupal.behaviors.disableSubFilter = {
    attach: function(context, settings) {
      var main_cat_selected = $(
        ".js-facet-block-id-memberspecialfield option:selected"
      ).val();

      if (main_cat_selected == "") {
        $(".js-facet-block-id-memberspecialfieldsimple select").attr(
          "disabled",
          "disabled"
        );
        $(".js-facet-block-id-memberspecialfieldsimple select").addClass(
          "disabled"
        );

        $(".js-facet-block-id-memberspecialfieldsimple select").attr(
          "disabled",
          "disabled"
        );
        $(".js-facet-block-id-memberspecialfieldsimple select").addClass(
          "disabled"
        );
      } else {
        $(".js-facet-block-id-memberspecialfieldsimple select").removeAttr(
          "disabled"
        );
        $(".js-facet-block-id-memberspecialfieldsimple select").removeClass(
          "disabled"
        );

        $(".js-facet-block-id-memberspecialfieldsimple select").removeAttr(
          "disabled"
        );
        $(".js-facet-block-id-memberspecialfieldsimple select").removeClass(
          "disabled"
        );
      }
    }
  };

  Drupal.exposedFilterOpen = false;

  // Add class on click to an element
  function addClassOnclick($element, $class) {
    if ($element.hasClass($class)) {
      $element.removeClass($class);
    } else {
      $element.addClass($class);
    }
  }

  Drupal.behaviors.node49HashchangeHack = {
    attach: function(context, settings) {
      $(once("node49HashchangeHack", ".page-node-49", context)).each(
        function() {
          $(window).on("hashchange", function() {
            window.location.reload(false);
          });
        }
      );
    }
  };

  Drupal.behaviors.anchorLinks = {
    attach: function(context, settings) {
      $(once("anchorLinks", "html, body", context)).each(function() {
        var hash = window.location.hash;
        if (hash && $(window).width() >= 960) {
          let menuOffset = 215; // default offset for the normal menu
          const menuBLock = $("nav.menu-block"); // dynamic offset for the landingpage menu
          if (menuBLock.length) {
            menuOffset = menuBLock.outerHeight();
          }
          setTimeout(function() {
            $("html,body")
              .stop()
              .animate({ scrollTop: $(hash).offset().top - menuOffset }, 100);
          }, 50);
        } else if (hash && $(window).width() <= 960) {
          $("html,body")
            .stop()
            .animate({ scrollTop: $(hash).offset().top - 30 }, 100);
        }
      });
    }
  };

  // Facets 3.x dropdowns do a full page reload (they dropped the built-in Views
  // AJAX). Preserve the scroll position across that reload instead of jumping to
  // the top: remember it right before the reload and restore it afterwards.
  Drupal.behaviors.memberFilterKeepScroll = {
    attach: function(context, settings) {
      $(once("memberFilterSaveScroll", ".js-facets-widget", context)).on(
        "facets_filter.facets",
        function() {
          try {
            window.sessionStorage.setItem("smtMemberScroll", String(window.pageYOffset));
          } catch (e) {}
        }
      );

      $(once("memberFilterRestoreScroll", ".region-content-white", context)).each(function() {
        var search = window.location.search;
        if (search.indexOf("f[") === -1 && search.indexOf("f%5B") === -1) {
          return;
        }
        var saved;
        try {
          saved = window.sessionStorage.getItem("smtMemberScroll");
          window.sessionStorage.removeItem("smtMemberScroll");
        } catch (e) {}
        if (saved === null || saved === undefined) {
          return;
        }
        var y = parseInt(saved, 10);
        if (isNaN(y)) {
          return;
        }
        var restore = function() {
          window.scrollTo(0, y);
        };
        restore();
        $(window).one("load", restore);
        setTimeout(restore, 400);
      });
    }
  };

  /*
   * Header
   */
  Drupal.behaviors.menuFunction = {
    attach: function(context, settings) {
      // Flyoutnavigation
      $(once("menuFunction", ".menu-icon", context)).on("click", function(
        event
      ) {
        event.preventDefault();
        $(".flyoutnavigation").slideToggle("fast");
        $(".header").toggleClass("menu-extended");
        $("body").toggleClass("header-fixed-overflow");
        $(".header-fixed")
          .removeClass("is-not-top")
          .addClass("is-top");
      });

      // Dropdown
      var windowsWidth = $(window).width();

      // Check if the window is under 960px
      if (windowsWidth < 960) {
        $(
          once("menuFunctions", "#block-hauptnavigation .menu-firstchild > a")
        ).on("click", function(event) {
          event.preventDefault();
          $(this)
            .next()
            .slideToggle("fast");
        });
      } else {
        $("#block-hauptnavigation .menu-firstchild > a").off("click");
      }
    }
  };

  /*
   * Header on scroll
   */
  Drupal.behaviors.menuOnScroll = {
    attach: function(context, settings) {
      // Fix header on scroll
      var previousScroll = 0;

      $(window).on("scroll", function() {
        var currentScroll = $(this).scrollTop();

        if (!$(".header").hasClass("menu-extended") && currentScroll > 85) {
          if (currentScroll > previousScroll) {
            // Add Class when the Nav is not Top
            $(".header-fixed")
              .removeClass("is-top")
              .addClass("is-not-top");
          } else {
            // Add Class when the Nav is Top
            $(".header-fixed")
              .removeClass("is-not-top")
              .addClass("is-top");
          }
        }
        previousScroll = currentScroll;
      });
    }
  };

  /*
   * Landingpage Header on scroll
   */
  Drupal.behaviors.landingpageHeaderonScroll = {
    attach: function(context, settings) {
      const menu = $(".menu-block");
      const meta = menu.find(".menu-block__meta");

      menu.closest(".block-swissmedtech-smtday-blocks").height(menu.height());

      const stickyOffset = menu?.offset()?.top ?? 0;
      let lastScrollTop = stickyOffset;

      $(window).on("scroll", function() {
        if ($(window).width() > 960) {
          const currentScroll = $(this).scrollTop();
          // Logic for sliding the meta up and down
          if (currentScroll >= lastScrollTop && !meta.is(":hidden")) {
            meta.slideUp();
          } else if (currentScroll < lastScrollTop && meta.is(":hidden")) {
            meta.slideDown();
          }

          // Logic for fixing the menu
          if (currentScroll > stickyOffset) {
            menu.addClass("menu-block--fixed");
          } else {
            menu.removeClass("menu-block--fixed");
          }

          lastScrollTop = currentScroll;
        }
      });
    }
  };

  /*
   * Landingpage Mobile Menu
   */
  Drupal.behaviors.landingpageMobileMenu = {
    attach: function(context, settings) {
      $(once("landingpageMobileMenu", ".menu-block__menu-icon", context)).on(
        "click",
        function(event) {
          $(".menu-block__mobile-wrapper").slideToggle("fast");
          $(this).toggleClass("menu-block__menu-icon--open");
        }
      );
    }
  };

  /*
   * Person overlay
   */
  Drupal.behaviors.overlayFunction = {
    attach: function(context, settings) {
      $(window).on("load resize", function() {
        var $width = $(this).width();

        if ($width > 960) {
          $(".overlay").on("click", function(event) {
            event.preventDefault();
            var $person = $(this)
              .closest(".person-portrait")
              .next(".person-overlay");
            $person.addClass("open");
            $("body").addClass("fix-content");
          });

          $(".close").on("click", function(event) {
            event.preventDefault();
            var $person = $(this).closest(".person-overlay");
            $person.removeClass("open");
            $("body").removeClass("fix-content");
          });

          $(".person-overlay").on("click", function(event) {
            event.preventDefault();
            $(this).removeClass("open");
            $("body").removeClass("fix-content");
          });
        }
      });
    }
  };

  /*
   * Toggle accordion
   */
  Drupal.behaviors.accordionToggle = {
    attach: function(context, settings) {
      $(once("accordionToggle", ".dropdown-toggle", context)).each(function() {
        var accordion = $(this);
        var accordionContent = accordion.find(".dropdown-content");
        var accordionTitle = accordion.find(".dropdown-title");

        accordionTitle.on("click", function() {
          accordionContent.toggleClass("dropdown-open");
          $(this).toggleClass("flip");
          $(this)
            .parent(".dropdown-wrapper")
            .toggleClass("drop_open");
        });
      });
    }
  };

  /*
   * Open Members List Section
   */
  Drupal.behaviors.openSection = {
    attach: function(context, settings) {
      $(once("openSection", ".view-member-list .views-row")).each(
        this.attachLink
      );
    },
    attachLink: function(idx, column) {
      $(this)
        .find(".o-locality")
        .on("click", function(e) {
          e.stopPropagation();
          var $data = $(this)
            .closest(".member-teaser-div-1")
            .next(".member-teaser-div-2")
            .find(".member-teaser--hidden > .locality");
          var $taxonomie = $(this)
            .closest(".member-teaser-div-1")
            .next(".member-teaser-div-2")
            .find(".member-teaser--hidden > .taxonomy");
          var $geo_link = $(this)
            .closest(".member-teaser-div-1")
            .next(".member-teaser-div-2")
            .find(".member-teaser--hidden > a.o-geolocation");
          var $geo_map = $(this)
            .closest(".member-teaser-div-1")
            .next(".member-teaser-div-2")
            .find(".member-teaser--hidden > .geolocation");

          $(this).toggleClass("flip");
          $geo_link.toggleClass("show");

          if ($data.hasClass("location-open")) {
            $data.removeClass("location-open");
            $taxonomie.removeClass("taxonomy-open");
            $geo_map.removeClass("geolocation-open");
            $geo_link.removeClass("flip");
          } else {
            $data.addClass("location-open");
            $taxonomie.addClass("taxonomy-open");
          }
        });
    }
  };

  /*
   * Open Members List Map
   */
  Drupal.behaviors.memberListMap = {
    attach: function(context, settings) {
      $(once("memberListMap", ".view-member-list .views-row")).each(
        this.attachLink
      );
    },
    attachLink: function(context, settings) {
      $(this)
        .find("a.o-geolocation")
        .on("click", function(e) {
          e.stopPropagation();
          var $geo_map = $(this)
            .parent()
            .find(".geolocation");
          if ($geo_map.hasClass("geolocation-open")) {
            $geo_map.removeClass("geolocation-open");
            $(this).removeClass("flip");
          } else {
            $geo_map.addClass("geolocation-open");
            $(this).addClass("flip");
          }
        });
    }
  };

  /*
   * Members List Mobile Title
   */
  Drupal.behaviors.memberListMobileTitle = {
    attach: function(context, settings) {
      $(once("memberListMobileTitle", ".view-member-list .views-row")).each(
        this.attachLink
      );
    },
    attachLink: function(context, settings) {
      $(this)
        .find(".member-teaser__title")
        .on("click", function(e) {
          e.stopPropagation();
          var $data = $(this)
            .closest(".member-teaser-div-1")
            .next(".member-teaser-div-2")
            .find(".member-teaser--hidden");
          addClassOnclick($(this), "flip");
          addClassOnclick($data, "open");
        });
    }
  };

  /*
   * Members List Mobile Button
   */
  Drupal.behaviors.memberListMobileMapButton = {
    attach: function(context, settings) {
      $(once("memberListMobileMapButton", ".view-member-list .views-row")).each(
        this.attachLink
      );
    },
    attachLink: function(context, settings) {
      $(this)
        .find(".cardbtn")
        .on("click", function(e) {
          e.stopPropagation();
          var $data = $(this)
            .closest(".member-teaser-div-2")
            .find(".geolocation");
          addClassOnclick($data, "geolocation-open");
        });
    }
  };

  /*
   * Autocomplete search
   */
  Drupal.behaviors.autocomplete_search = {
    attach: function(context, settings) {
      $(once("autocomplete_search", "input.autocomplete-search", context)).each(
        function() {
          $.widget("custom.catcomplete", $.ui.autocomplete, {
            _create: function() {
              this._super();
              this.widget().menu(
                "option",
                "items",
                "> :not(.ui-autocomplete-category)"
              );
            },
            _renderMenu: function(ul, items) {
              var that = this;

              var map = new Map();
              $.each(items, function(index, item) {
                if (map[item.category] === undefined) {
                  map[item.category] = [];
                }
                map[item.category].push(item);
              });

              // sort keys
              let keys = Object.keys(map);
              keys.sort(function(a, b) {
                if (map[a][0].relevance === map[b][0].relevance) {
                  return 0;
                }
                if (map[a][0].relevance < map[b][0].relevance) {
                  return 1;
                }
                return -1;
              });

              var sorted_map = new Map();
              for (let i = 0; i < keys.length; i++) {
                sorted_map[keys[i]] = map[keys[i]];
              }

              $.each(sorted_map, function(cat, items) {
                var li;

                ul.append(
                  "<li class='ui-autocomplete-category'><strong>" +
                    cat +
                    "</strong></li>"
                );

                $.each(items, function(index, item) {
                  li = that._renderItemData(ul, item);
                  li.attr("aria-label", item.category + " : " + item.label);
                });
              });
            }
          });

          var lang = drupalSettings.path.currentLanguage;
          var cache = {};
          $("input.autocomplete-search").catcomplete({
            source: function(request, response) {
              var term = request.term;
              if (term in cache) {
                response(cache[term]);
                return;
              }
              $.get(
                "/api/search?fulltext=" + term + "&langcode=" + lang,
                function(data) {
                  if (data.length > 0) {
                    cache[term] = data;
                    response(data);
                  }
                }
              );
            },
            minLength: 3,
            select: function(event, ui) {
              setTimeout(function() {
                Drupal.searchGoto(ui.item.url);
              }, 1000);
            }
          });
        }
      );
    }
  };

  Drupal.searchSubmitted = false;

  Drupal.searchGoto = function(url) {
    if (!Drupal.searchSubmitted) {
      Drupal.searchSubmitted = true;
      window.location.href = url;
    }
  };

  /*
   * Search animation
   */
  Drupal.behaviors.searchInputAnimation = {
    attach: function(context, settings) {
      var $searchBtn = $(".search-icon");
      var $searchForm = $("#autocomplete-search-form");
      var $searchInput = $(".autocomplete-search");

      $(once("searchInputAnimation", $searchBtn)).on("click", function(e) {
        addClassOnclick($searchForm, "show");
        addClassOnclick($searchBtn, "flip");
        $searchInput.trigger("focus");
      });
    }
  };

  /*
   * Webforms labels
   */
  Drupal.behaviors.inputFloatingLabel = {
    attach: function(context, settings) {
      var formFields = $(".form-item");

      formFields.each(function() {
        var field = $(this);
        var input = field.find("input");
        var textarea = field.find("textarea");
        var label = field.find("label");

        // Check if input is fill
        input.filter(function() {
          if (input.val().length > 0) {
            label.addClass("float-label");
          } else {
            label.removeClass("float-label");
          }
        });

        textarea.filter(function() {
          if (textarea.val().length > 0) {
            label.addClass("float-label");
          } else {
            label.removeClass("float-label");
          }
        });

        // Add floating label on focus in
        input.on("focusin", function() {
          label.addClass("float-label");
        });

        textarea.on("focusin", function() {
          label.addClass("float-label");
        });

        // Delete floating label on focus in
        input.on("focusout", function() {
          if (!input.val()) {
            label.removeClass("float-label");
          } else {
            label.addClass("float-label");
          }
        });

        textarea.on("focusout", function() {
          if (!textarea.val()) {
            label.removeClass("float-label");
          } else {
            label.addClass("float-label");
          }
        });
      });
    }
  };

  /*
   * Fix timeline on scroll
   */
  Drupal.behaviors.timelineOnScroll = {
    attach: function(context, settings) {
      $(once("timelineOnScroll", ".page-node-type-history", context)).each(
        function() {
          $(window).on("scroll", function() {
            var timeline = $(".timeline-years");
            if ($(window).scrollTop() >= 450) {
              timeline.addClass("fix-timeline");
            } else {
              timeline.removeClass("fix-timeline");
            }
            if (
              timeline.offset().top + timeline.height() >=
              $("footer").offset().top - 350
            ) {
              timeline.removeClass("fix-timeline");
            }
          });
        }
      );
    }
  };

  /*
   * Make div clickable
   */
  Drupal.behaviors.clickBannerCta = {
    attach: function(context, settings) {
      $(".banner-block__cta").on("click", function() {
        window.location = $(this)
          .find("a")
          .attr("href");
        return false;
      });
    }
  };

  /*
   * Automatically adjust banner height to absolute image
   */

  Drupal.behaviors.smtBannerHeight = {
    attach: function(context, settings) {
      $(window).on("resize", function() {
        var targetheight = $(".smtday_header_media").css("height");
        $(".smtday_header").css("height", targetheight);
        $(".smtday_header").css("margin-bottom", "39px");
      });
    }
  };

  Drupal.behaviors.smtBannerHeightonLoad = {
    attach: function(context, settings) {
      $(window).on("load", function() {
        var targetheight = $(".smtday_header_media").css("height");
        $(".smtday_header").css("height", targetheight);
        $(".smtday_header").css("margin-bottom", "39px");
      });
    }
  };

  /*
   * Anchor Navigation (Startpage)
   */
  Drupal.behaviors.anchorNavigation = {
    attach: function(context, settings) {
      $(".path-frontpage", context).each(function() {
        var $sections = $(".anchor-link");

        $(window).on("scroll", function() {
          var currentScroll = $(this).scrollTop();
          var $currentSection;

          $sections.each(function() {
            var divPosition = $(this).offset().top;

            if (divPosition - 300 < currentScroll) {
              $currentSection = $(this);
            }
            if ($currentSection) {
              var id = $currentSection.attr("id");
              $(".anchor-menu-item > a").removeClass("active-anchor");
              $("[href='#" + id + "']").addClass("active-anchor");
            }
          });
        });
      });
    }
  };

  /*
   * Anchor Navigation Links (Startpage)
   */
  Drupal.behaviors.navigationAnchorLinks = {
    attach: function(context, settings) {
      $(".path-frontpage", context).each(function() {
        $('a[href*="#"]:not([href="#"])').on("click", function() {
          var offset = -200; // <-- change the value here
          if (
            location.pathname.replace(/^\//, "") ==
              this.pathname.replace(/^\//, "") &&
            location.hostname == this.hostname
          ) {
            var target = $(this.hash);
            target = target.length
              ? target
              : $("[name=" + this.hash.slice(1) + "]");
            if (target.length) {
              $("html, body").animate(
                {
                  scrollTop: target.offset().top + offset
                },
                100
              );
              return false;
            }
          }
        });
      });
    }
  };

  Drupal.behaviors.resetSearchField = {
    attach: function(context, settings) {
      $(once("resetSearchField", ".reset-search")).on("click", function() {
        $("input[name=search_api_fulltext]").val("");
        window.location = $(this).attr("href");
        window.location.reload();
      });
    }
  };

  Drupal.behaviors.flipCard = {
    attach: function(context, settings) {
      $(".flip-card-block", context).each(function() {
        const $this = $(this);
        window.addEventListener("resize", checkSize);

        function checkSize() {
          const front = $this.find(".flip-card__front");
          const back = $this.find(".flip-card__back");
          const card = $this.find(".flip-card");
          const frontHeight = front.outerHeight();
          const backHeight = back.outerHeight();

          if (frontHeight > backHeight) {
            card.height(frontHeight);
            back.css("min-height", frontHeight);
          } else {
            card.height(backHeight);
          }
        }

        checkSize();
      });
    }
  };

  /**
   * Behavior for Key Figures block.
   */
  Drupal.behaviors.keyFigures = {
    attach: function(context, settings) {
      once("key-figures-slider", ".key-figures-slider", context).forEach(
        function(slider) {
          const $slider = $(slider);
          const $currentSlide = $slider.find(".key-figures-slider-current");
          const currentLang = drupalSettings.path.currentLanguage;

          let separator = ",";
          if (currentLang === "de" || currentLang === "it") {
            separator = "’";
          } else if (currentLang === "fr") {
            separator = " ";
          }

          const counters = [];
          $slider.find(".key-figures-card-number").each(function() {
            const $counter = $(this);
            const targetValue = parseFloat($counter.data("number")) || 0;
            const isInteger = Number.isInteger(targetValue);

            const countUpInstance = new CountUp($counter[0], targetValue, {
              duration: 2.5,
              decimalPlaces: isInteger ? 0 : 1,
              separator: separator
            });

            if (!countUpInstance.error) {
              counters.push({
                element: $counter,
                instance: countUpInstance,
                hasRun: false
              });
            } else {
              console.error(countUpInstance.error);
            }
          });

          // Setup Intersection Observer to trigger countUp when number elements are visible
          const observerOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 1.0
          };

          const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const $numberElement = $(entry.target);

                // Find the corresponding counter for this number element
                counters.forEach(counter => {
                  if (
                    counter.element[0] === $numberElement[0] &&
                    !counter.hasRun
                  ) {
                    // Start counter with a 100ms delay
                    setTimeout(() => {
                      counter.instance.start();
                      counter.hasRun = true;
                    }, 100);
                  }
                });
              }
            });
          }, observerOptions);

          // Observe each number element
          $slider.find(".key-figures-card-number").each(function() {
            observer.observe(this);
          });

          // Update the current slide number
          UIkit.util.on(slider, "itemshow", function(e) {
            const currentIndex = e.detail[0].index || 0;
            $currentSlide.text(currentIndex + 1);
          });
        }
      );
    }
  };
})(jQuery, window, document, Drupal, UIkit, CountUp);

export default custom;

//Add Line for Mobile Menu
const footerMobileDefineElement = document.createTextNode("|");

const footerMobileGetElement = document.querySelector(
  "#block-menufootermobile .menu .menu-item"
);

if (footerMobileGetElement) {
  footerMobileGetElement.parentNode.insertBefore(
    footerMobileDefineElement,
    footerMobileGetElement.nextSibling
  );
}
